import { parentActiveState, parentHoverState, widgetSelector } from './helpers';
import { getStyleDeclaration } from './get-style-declaration';
import { getWidgetGeometry } from '../recalculate-positions';

export function closeButtonWidget(widgetDescription) {
  const { placements, styledStates, width, height, iconSize } =
    widgetDescription;
  const selector = widgetSelector(widgetDescription);
  const fullscreenSelector = `*[data-display-mode="fullscreen"] > ${selector}`;
  const rules = [...placements.map(getStyleDeclaration.size(selector))];

  rules.push([
    selector,
    [
      /* it should be over all other widgets, include large "scroll" container  */
      ['z-index', '1'],
    ],
  ]);

  /* apply fixed position only for button on fullscreen slides,
   popup's button should respect "safe zone"  */
  rules.push([fullscreenSelector, [['position', 'fixed']]]);

  if (isPositionedByCoordinates(widgetDescription.style, false)) {
    rules.push(
      ...placements.map(getStyleDeclaration.positions(fullscreenSelector)),
    );
  }

  rules.push([`.mobile ${selector}`, [['height', 'initial']]]);

  if (widgetDescription.version === 2) {
    rules.push([selector, [['border-radius', '50%']]]);

    const iconGeometry = getWidgetGeometry(
      {
        width: iconSize,
        height: iconSize,
      },
      width,
      height,
    );
    rules.push([
      `${selector} [role="close-icon"]`,
      [
        ['width', iconGeometry.relativeSize.width],
        ['height', iconGeometry.relativeSize.height],
      ],
    ]);

    if (styledStates) {
      const { default: base, hover, click: active } = styledStates;

      rules.push([
        `${selector} [role="close-icon"] path`,
        [['stroke', base.iconColor]],
      ]);
      rules.push([
        parentHoverState(selector, '[role="close-icon"] path'),
        [['stroke', hover.iconColor]],
      ]);
      rules.push([
        parentActiveState(selector, '[role="close-icon"] path'),
        [['stroke', active.iconColor]],
      ]);
    }
  }

  return rules;
}

function isPositionedByCoordinates(styles) {
  const hasPadding = styles.top || styles.left || styles.right || styles.bottom;
  return !hasPadding;
}
